import * as React from "react";
import {ClientAlertForm, ClientForm} from "../../types/clients";
import {Severity} from "../../types/types";

export const ManageContactsButton = (props: {
  clientForm: ClientForm,
  disconnectedAlert: ClientAlertForm,
  severity: Severity,
  limitName: 'RC1' | 'RC2' | 'RC6' | 'Virtual Server' | 'REV',
  displayManageContactsOverlay: (clientForm: ClientForm, disconnectedAlert: ClientAlertForm, severity: Severity) => void
}) => {
  const disconnectedAlert = props.disconnectedAlert;
  const disconnectBadgeClass =
    disconnectedAlert.contacts.size > 0 ? 'badge-notify' : props.limitName === "REV" ? 'badge-warn' : 'badge-breach'

  return <button
    className='button no-margin-top'
    onClick={() => props.displayManageContactsOverlay(props.clientForm, disconnectedAlert, props.severity)}
    type='button'
  >
    {props.limitName} {props.severity} Recipients
    <span className={`badge ${disconnectBadgeClass} theme--black-on-white`}>
        {disconnectedAlert.contacts.size}
    </span>
  </button>
}
